import { queryPayStatus } from "$couponPackage/api/index";

export default {
  data() {
    return {
      ispaying: false,
      payState: 0
    }
  },
  methods: {
    goOrderDetail(id) {
      this.$router.push({
        name: 'order-detail',
        query: {
          id: id,
          timestramp: new Date().getTime()
        }
      }).catch(err => console.log('跳转报错', err))
    },
    ajaxQueryPayStatus(params) {
      console.log('进入支付查询 ajaxQueryPayStatus', this.ispaying, params.aggregateOrderNo)
      // 查接口
      Vue.filter("loading")(true);
      queryPayStatus(
        {
          aggregateOrderNo: params.aggregateOrderNo
        },
        {
          success: res => {
            Vue.filter("loading")(false);
            console.log("queryPayStatus success res", res);
            const { payState } = res
            this.payState = payState
            // INIT :初始 10; WAIT_PAY :待支付 17 ;PAYING :支付中 11 ;PAYED :支付完成 12 ;PAY_FAIL :支付失败 13 ;
            // REFUNDING :退款中 14 ;REFUNDED :退款完成 15 ;CLOSE :关闭 16;
            // 支付成功
          },
          fail: err => {
            console.log("queryPayStatus fail", err);
          },
          complete: () => {
            console.log('queryPayState+++++++++++++++++++++++++>', this.payState)
            if (this.payState === 12) {
              this.ispaying = false
              this.$router.push({
                name: 'pay-result',
                query: {
                  aggregateOrderNo: params.aggregateOrderNo,
                  orderNo: params.orderNo,
                  id: params.id
                }
              })
            } else if (this.payState < 12) {
              console.log('res+++++++++++++++++++', this.payState);
              setTimeout(() => {
                this.ajaxQueryPayStatus(params)
              }, 500)
            } else {
              this.goOrderDetail(params.id)
            }
          }
        }
      );
    }
  }
}
